import { createContext } from 'react';
import { Context } from 'models';

const AuthContext = createContext<Context | null>(null);

export default AuthContext;
